import { createRoot } from 'react-dom/client';

import AgentAnalyticsSchedulePanel from './Panels/AgentAnalyticsSchedulePanel';
import AgentSettingsIntegrationPanel from './Panels/AgentSettingsIntegrationPanel';
import AgentSettingsVoIPPhonePanel from './Panels/AgentSettingsVoIPPhonePanel';
import CommissionsPanel from './Panels/CommissionsPanel';

import EmailInboxButton from './Buttons/EmailInboxButton';
import { AgencyEnrollmentSetupPanel } from './Panels/AgencyEnrollmentSetupPanel';
import { AgencySettingsUploadsPanel } from './Panels/AgencySettingsUploadsPanel';
import { AgencyUserIpManagementPanel } from './Panels/AgencyUserIpManagementPanel';
import AgentEnrollmentPanel from './Panels/AgentEnrollmentPanel';
export class PanelRenderer {
  settings = {};

  constructor(settings = {}) {
    this.settings = settings;
  }

  syncData() {
    let promises = [];

    if (this.settings.indId && !this.settings.ind) {
      var individualRepository = new MedicareProAPI.IndRepository();
      individualRepository.setAccessToken(this.settings.userAccessToken);

      promises.push(
        individualRepository
          .getInd(this.settings.indId, {
            include: [
              'emails',
              'addresses',
              'spouse',
              'spouse.emails',
              'spouse.addresses',
              'policies',
              'policies.company',
              'policies.plan',
              'policies.accountValues',
              'providers',
            ],
            ownerId: this.settings.userId,
          })
          .then((individual) => {
            this.settings.ind = individual;
            return individual;
          })
      );
    }

    if (this.settings.userId && !this.settings.user) {
      var userRepository = new MedicareProAPI.UserRepository();
      userRepository.setAccessToken(this.settings.userAccessToken);

      promises.push(
        userRepository.getUser(this.settings.userId).then((user) => {
          this.settings.user = user;
          return user;
        })
      );
    }

    return Promise.all(promises);
  }

  renderCommissionsPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<CommissionsPanel {...this.settings} />, element);
    }
  }

  renderAgentSettingsVoIPPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgentSettingsVoIPPhonePanel {...this.settings} />, element);
    }
  }

  renderAgentSettingsIntegrationPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgentSettingsIntegrationPanel {...this.settings} />, element);
    }
  }

  renderAgentAnalyticsSchedulePanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgentAnalyticsSchedulePanel {...this.settings} />, element);
    }
  }

  renderAgencySettingsUploadsPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgencySettingsUploadsPanel {...this.settings} />, element);
    }
  }

  renderAgencyEnrollmentSetupPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgencyEnrollmentSetupPanel {...this.settings} />, element);
    }
  }

  renderAgencyUserIpManagementPanel(path) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgencyUserIpManagementPanel {...this.settings} />, element);
    }
  }

  renderEmailInboxButton(path, agency = null) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      this.syncData().then((responses) => {
        this.settings['agency'] = agency;
        root.render(<EmailInboxButton {...this.settings} />, element);
      });
    }
  }

  renderAgentEnrollmentButton(path, agency = null) {
    const element = document.querySelector(path);
    const root = createRoot(element);

    if (element) {
      root.render(<AgentEnrollmentPanel {...this.settings} />, element);
    }
  }

}